import React, { FC, useEffect } from 'react';
import cs from 'classnames';
import s from './mobileApp.scss';
import * as BIManager from '../../utils/bi';
import { MobileToolbar } from '../partials/MobileToolbar/MobileToolbar';
import { fedopsLogger } from '../../utils/fedops-logger';
import { useTemplateContext } from '../../context/TemplateContext/TemplateContext';
import { useUIContext } from '../../context/UIContext/UIContext';
import { InfoButton } from '../InfoButton/InfoButton';
import { InfoPopUp } from '../InfoPopUp/InfoPopUp';
import { mobileAppDataHooks } from './MobileApp.dataHooks';
import { MobileWixStudioToolbar } from '../partials/MobileWixStudioToolbar/MobileWixStudioToolbar';
import { buildIframeUrl } from '../../utils/urlBuilders';

export const MobileApp: FC<{ dataHook?: string }> = ({ dataHook }) => {
  const { isInfoShown } = useUIContext();
  const { template } = useTemplateContext();
  const { url, title, isStudio } = template;
  const previewUrl = buildIframeUrl(url, { showMobileView: true });

  useEffect(() => {
    BIManager.reportLoadSuccess();
    fedopsLogger.appLoaded();
  }, []);

  let toolbar: React.ReactNode;

  if (isStudio) {
    toolbar = <MobileWixStudioToolbar dataHook={mobileAppDataHooks.wixStudioToolbar} />;
  } else {
    toolbar = (
      <MobileToolbar dataHook={mobileAppDataHooks.mobileToolBar}>
        <InfoButton dataHook={mobileAppDataHooks.infoView} />
      </MobileToolbar>
    );
  }

  return (
    <div data-hook={dataHook}>
      {toolbar}
      <iframe
        data-hook={mobileAppDataHooks.mobileIframe}
        title={title}
        src={previewUrl}
        className={cs(s.iframe, { [s.iframeHidden]: isInfoShown })}
      />
      {!isStudio && <InfoPopUp isMobile dataHook={mobileAppDataHooks.infoPopUp} />}
    </div>
  );
};
